<template>
  <div class="page">
    <h2>Оплата заказа</h2>
    <button @click="pay" class="pay-btn">Оплатить</button>
  </div>
</template>

<script>
export default {
  methods: {
    async pay() {
      try {
        const res = await fetch("http://localhost:3000/payments/create", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            orderId: Date.now(),
            amount_sums: 100000
          })
        });
        const data = await res.json();
        if (data.checkoutUrl) {
          window.location.href = data.checkoutUrl;
        } else {
          alert("Ошибка при создании счёта");
        }
      } catch (err) {
        console.error(err);
        alert("Ошибка соединения с сервером");
      }
    }
  }
};
</script>

<style scoped>
.pay-btn {
  background: #2196f3;
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 16px;
  cursor: pointer;
  transition: background 0.3s;
}
.pay-btn:hover {
  background: #1769aa;
}
</style>
